import React from 'react'
import VerticalGroup from '../../atoms/VerticalGroup/VerticalGroup'
import Text from '../../atoms/Text/Text'

interface InAppHelpContentProps {
  heading: string
  children: React.ReactNode
}

const InAppHelpContent: React.FC<InAppHelpContentProps> = ({
  heading,
  children,
}) => (
  <VerticalGroup start gap={4}>
    <Text left weight="bold" size="xl">
      {heading}
    </Text>
    {children}
  </VerticalGroup>
)

export default InAppHelpContent
